<template>
  <v-app-bar
    app
    dense
    color="authAppbar"
    clipped-left
  >
    <v-row
      class="pa-0"
      align="center"
      justify="center"
    >
      <v-col
        cols="4"
        class="pa-0"
        align="center"
        justify="center"
      >
        <img
          :src="_appBarLogo"
          height="30"
        >
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
export default {
  computed: {
    _appBarLogo() {
      return require("@/__vue2cmsstonevuetify/assets/img/app-bar-logo.svg");
    },
  },
};
</script>

<style>
</style>